<template>
    <div class="form-input" :class="{disabled}">
        <label v-if="label !== ''">{{ label }} <span v-if="required" class="required">*</span></label>
        <div class="input">
            <input :type="isNumber?'number':'text'" :placeholder="placeholder" :value="value" @input="handleInput" :readonly="readonly" @change="change" ref="input" @keydown.enter="change" :disabled="disabled">
            <div class="after" v-if="after !== ''">{{ after }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "input-text",
    props:{
        value:{type:[String,Number]},
        label:String,
        placeholder:String,
        after:{type:String,default:""},
        required:Boolean,
        readonly:Boolean,
        isNumber:Boolean,
        disabled:Boolean,
    },
    methods:{
        handleInput(e){
            let val = e.target.value
            if(this.isNumber){
                val = parseInt(val || 0)
            }
            this.$emit("input",val)
        },
        change(e){
            let val = e.target.value
            if(this.isNumber){
                val = parseInt(val)
            }
            this.$emit("change",val)
        },
        focusInput(){
            this.$refs["input"].focus();
        },
        selectInput(){
            this.$refs["input"].select();
        }
    }
}
</script>